import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { LanguageCode, LanguageCodes } from "../../../library-js/i18n/LanguageCode";
import { MultiString } from "../../../library-js/i18n/MultiString";

export class LangBlock
{
  static type = new ElementType( "lang-block" );
  static lang = new ElementAttribute( "lang" );

  static getLanguage( e:Element )
  {
    return LangBlock.lang.from( e ) as LanguageCode;
  }
  static createHTML( multiString:MultiString, container?:Element )
  {
    container = container || ( ElementType.span.create() );

    LanguageCodes.all.forEach(
      ( lc )=>
      {
        let value = MultiString.fromCode( multiString, lc ) || multiString.en;
        let block = LangBlock.type.create( value );
        LangBlock.lang.to( block, lc );
        container.appendChild( block );
      }
    );

    return container;
  }
}